// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180730/js/" + chunkId + "." + {"44":"f227904a","225":"d8d916a7","481":"b110c6e5","486":"2b63ede3","770":"1cac52b6"}[chunkId] + ".0.4037338612597732.chunk.js";
};